// DTOs de la pantalla del técnico "Líneas y paros" (/mantenimiento/lineas).
//
//   - GET /api/mantenimiento/lineas-estado?planta_id=
//   - GET /api/mantenimiento/lineas-estado/:lineaId/paros
//
// Espejo del grid S1 del supervisor (misma query sobre vw_kpis_linea_turno +
// LATERAL de paro activo) pero con gate del módulo (puede_ver_mantenimiento)
// en vez de rol supervisor. Reusa los schemas de S1 para que el clon sea
// byte-compatible y el FE reutilice el semáforo/celda existente.
import { z } from 'zod';
import { lineaSchema } from './linea.js';
import { supervisorKpiLineaSchema, turnoObjetivoSchema } from './supervisor_dashboard.js';
import { paroMttoItemSchema } from './mantenimiento_paros_validacion.js';
export const lineasEstadoMttoQuerySchema = z.object({
    planta_id: z.string().uuid().optional(),
});
export const lineaEstadoMttoSchema = z.object({
    linea: lineaSchema,
    /** null = sin captura HOY en el turno objetivo (esperando captura). */
    kpi: supervisorKpiLineaSchema.nullable(),
    /** Paros del día operativo en la línea (todos los turnos, estado válido). */
    paros_hoy_count: z.number().int().min(0),
    /** Paros del día pendientes de validación de mantenimiento (cerrados). */
    paros_pendientes_count: z.number().int().min(0),
});
export const lineasEstadoMttoResponseSchema = z.object({
    tenant: z.object({ id: z.string().uuid(), nombre: z.string() }),
    /** Turno con el que se filtró el KPI (misma resolución que S1). */
    turno_objetivo: turnoObjetivoSchema,
    lineas: lineaEstadoMttoSchema.array(),
    fecha_hoy: z.string().date(),
    hora_servidor: z.string(),
});
// =============================================================================
// Drill de una línea: paros del día operativo
// =============================================================================
export const lineaParosDiaQuerySchema = z.object({
    /** Default: día operativo actual. */
    fecha: z.string().date().optional(),
});
export const lineaParosDiaResponseSchema = z.object({
    linea: z.object({
        id: z.string().uuid(),
        nombre: z.string(),
        planta_id: z.string().uuid(),
        planta_nombre: z.string(),
    }),
    fecha: z.string().date(),
    paros: paroMttoItemSchema.array(),
});
//# sourceMappingURL=mantenimiento_lineas_estado.js.map